__turbopack_context__.v({
  "grid": "_7xyzyW_grid",
  "large": "_7xyzyW_large",
  "slideInAnimation": "_7xyzyW_slideInAnimation",
  "title": "_7xyzyW_title",
});
